import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api_getCollectionProductsByProductId } from '~/backend/api_calls';
import { calculateProductPrice } from '~/common/helper';
import noimage_png from '~/images/no-image.png';

const CombineProducts = ({ productId }) => {
	const [collectionProducts, setCollectionProducts] = useState([]);
	const { t, i18n } = useTranslation();

	useEffect(() => {
		api_getCollectionProductsByProductId(productId)
			.then(json => setCollectionProducts(json.items))
			.catch(error => console.error(error));
	}, [productId]);

	if (collectionProducts.length === 0) return null;

	const product1 = collectionProducts[0];
	const product2 = collectionProducts[1];

	return (
		<>
			<div id="combine-products">
				<h3 className="combine-title">{t('complete_your_style')}</h3>
				<div className="combine-products">
					<a className="product-item" href={product1.eurl}>
						<div className="image-container">
							<img className="product-image" src={product1.img1 !== undefined ? product1.img1 : noimage_png} />
						</div>
						{/*<span className="product-status">NEW</span>*/}
						<span className="product-title">{product1.nm}</span>
						<span className="product-price">{calculateProductPrice(product1)}</span>
					</a>
					{product2 !== undefined && (
						<a className="product-item" href={product2.eurl}>
							<div className="image-container">
								<img className="product-image" src={product2.img1 !== undefined ? product2.img1 : noimage_png} />
							</div>
							{/*<span className="product-status">NEW</span>*/}
							<span className="product-title">{product2.nm}</span>
							<span className="product-price">{calculateProductPrice(product2)}</span>
						</a>
					)}
				</div>
			</div>
		</>
	);
};

CombineProducts.propTypes = {
	productId: PropTypes.number
};

export default CombineProducts;
